module.exports = __webpack_public_path__ + "img/icon-brain.62da89c6.svg";